import { IZitoneoScrapingExecution } from '../../types/entities/IZitoneoScrapingExecution';
import { ProcessState } from '../../types/processes/processTypes';

export type ScrapingExecutionProcess = Pick<
    IZitoneoScrapingExecution,
    'Id' | 'IdProcess'
> & {
    DateCreated: string | Date;
    Process: Pick<
        IZitoneoScrapingExecution['Process'],
        'Completed' | 'Cancelled' | 'Failed' | 'ProcessedTime' | 'Name'
    >;
};

/**
 * Maps projected scraping executions to activity process state.
 * @param executions The executions with their expanded process data.
 * @returns Processes with parsed creation dates and terminal-state activity.
 */
export const adaptProcessesToState = (
    executions: ScrapingExecutionProcess[]
): ProcessState[] => {
    return executions.map(execution => {
        const dateCreated =
            execution.DateCreated instanceof Date
                ? new Date(execution.DateCreated.getTime())
                : new Date(execution.DateCreated);
        if (Number.isNaN(dateCreated.getTime())) {
            throw new Error(
                `Invalid creation date for scraping execution ${execution.Id}`
            );
        }

        return {
            id: execution.Id,
            dateCreated,
            idProcess: execution.IdProcess,
            active:
                !execution.Process.Completed &&
                !execution.Process.Cancelled &&
                !execution.Process.Failed,
            processTime: execution.Process.ProcessedTime,
            name: execution.Process.Name,
        };
    });
};
